module.exports = __webpack_public_path__ + "static/img/hu.0d7409f8.svg";